/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import ChevronRight from "@endya-conformite/ui-kit/src/assets/icons/chevron-right.svg?react";
import classNames from "classnames";
import { Fragment, ReactElement } from "react";
import style from "./Breadcrumb.module.scss";

export type BreadcrumbProps<T> = {
  items: { label: string; value: T }[];
  separator?: ReactElement;
  selected: T;
  setSelected: (nextValue: T) => void;
  variant?: "hat" | "bald";
};

export function Breadcrumb<T>({
  items,
  separator = <ChevronRight className={style.separator} />,
  selected,
  setSelected,
  variant = "hat",
}: BreadcrumbProps<T>) {
  return (
    <div className={style.breadcrumb}>
      {items.map(({ label, value }, index) => {
        return (
          <Fragment key={label}>
            <span
              onClick={() => {
                setSelected(value);
              }}
              data-variant={variant}
              className={classNames(style.label, {
                [style.labelSelected]: value === selected,
              })}
            >
              {label}
            </span>
            {index !== items.length - 1 && separator}
          </Fragment>
        );
      })}
    </div>
  );
}
